var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 .55v42.9M105.833 6.833l30.334 30.334M105.833 37.167l30.334-30.334M142.45 22h-42.9",
    stroke: "#66D2FF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.343 22A47.526 47.526 0 0022 4.344 47.526 47.526 0 0039.657 22 47.527 47.527 0 0022 39.657 47.526 47.526 0 004.343 22z",
    stroke: "#E58AC5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.466 4.964c6.602-2.279 11.503 2.892 12.034 5.785.531-2.893 5.432-8.063 12.034-5.785 9.755 3.367 10.358 16.116 1.593 24.381C78.445 35.647 71.5 40.15 71.5 40.15s-6.944-4.503-13.628-10.805c-8.764-8.265-8.16-21.014 1.594-24.381z",
    stroke: "#FFAE8A",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
export default SvgStickerGroup;